import React, {useEffect} from 'react'
import {useDispatch} from 'react-redux'

import {useDeviceLayout} from '@daedalus/atlas/context/deviceLayout'
import {trackAccommodationPageSelectedDealMRP} from '@daedalus/core/src/analytics/utils/trackPerformanceMetrics'
import {
  SapiAbstractOffer,
  SapiAbstractOfferType
} from '@daedalus/core/src/room/types/room'

import {getRoomVariant} from '../RoomVariant/getRoomVariant/getRoomVariant'
import {SplitBookingCard} from '../SplitBookingCard'
import {RoomCard} from '.'

export type Props = {
  hotelId: string
  entity: SapiAbstractOffer
  isCheapest: boolean
  totalResults: number
  forceDefaultVariant?: boolean
}

export const RoomOrSplitBooking = ({
  hotelId,
  entity,
  isCheapest,
  totalResults,
  forceDefaultVariant = false
}: Props) => {
  const {isDesktop} = useDeviceLayout()
  const dispatch = useDispatch()

  // Tracking selected offer render performance
  useEffect(() => {
    if (
      entity.type === SapiAbstractOfferType.Regular &&
      entity.data.hasClickedOffer
    ) {
      trackAccommodationPageSelectedDealMRP(dispatch)
    } else if (
      entity.type === SapiAbstractOfferType.SplitBooking &&
      entity.data.isClicked
    ) {
      trackAccommodationPageSelectedDealMRP(dispatch)
    }
  }, [dispatch, entity])

  if (entity.type === SapiAbstractOfferType.Regular) {
    const room = entity.data
    return (
      <RoomCard
        key={room.id}
        hotelId={hotelId}
        room={room}
        variant={getRoomVariant({
          isCheapest,
          isSelected: room.hasClickedOffer,
          forceDefault: forceDefaultVariant
        })}
      />
    )
  }
  if (entity.type === SapiAbstractOfferType.SplitBooking) {
    const splitBooking = entity.data
    return (
      <SplitBookingCard
        key={entity.id}
        variant={getRoomVariant({
          isCheapest,
          isSplitBooking: true,
          isSelected: splitBooking.isClicked,
          forceDefault: isDesktop || forceDefaultVariant
        })}
        splitBooking={splitBooking}
        isCheapest={isCheapest}
        isOnlySplitBookingOfferAvailable={totalResults === 1}
      />
    )
  }
}
